import * as React from "react";
import { Button } from "@grandvisionhq/common";
/* empty css                  */
const LocaleOption = ({
  title,
  chooseLanguage,
  buttonCaption,
  path,
  locale,
  onSelect
}) => {
  const handleClick = () => {
    onSelect && onSelect(locale.replace("_", "-"), path);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "locale-option" }, /* @__PURE__ */ React.createElement("div", { className: "locale-option__title" }, title), /* @__PURE__ */ React.createElement("div", { className: "locale-option__choose-language" }, chooseLanguage), /* @__PURE__ */ React.createElement(Button, { className: "locale-option__cta", caption: buttonCaption, onClick: handleClick }));
};
export {
  LocaleOption as default
};
//# sourceMappingURL=LocaleOption.js.map
